import classnames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';

import { useIsBetweenXSmallAndMedium } from '../../../hooks/mediaQueries';
import useCardView from '../../../hooks/useCardView';
import EnergyLabelSvg from './EnergyLabelSvg';
import ProductDataSheet from './ProductDataSheet@default';

const EnergyInformation = ({ classes, energyRatingDetails, inline }) => {
	const { isDealsPage } = useSelector((state) => state);
	const { isGridView } = useCardView();

	const { ListerProductCardEnergyLabelEnabled } = useSelector(
		(state) => state.experimentSwitches
	);

	const isBetweenXSmallAndMedium = useIsBetweenXSmallAndMedium();

	const smallGrid = isBetweenXSmallAndMedium && isGridView;

	if (!energyRatingDetails) {
		return null;
	}

	const {
		EnergyRatingLabelUrl,
		ProductDatasheetPdfUrl,
		MaxEnergyRating,
	} = energyRatingDetails;

	const is2020Label = MaxEnergyRating === 'A';

	return (
		<div
			className={classnames(classes, {
				'flex justify-center z-20': isDealsPage,
				'items-center': isDealsPage && !smallGrid,
				'items-start': isDealsPage && smallGrid,
				'flex-col': isDealsPage && !inline,
			})}
			data-energyimageurl={EnergyRatingLabelUrl}>
			{!ListerProductCardEnergyLabelEnabled && (
				<EnergyLabelSvg
					energyRatingDetails={energyRatingDetails}
					is2020Label={is2020Label}
					customCatSmall
				/>
			)}
			<ProductDataSheet {...{ ProductDatasheetPdfUrl, is2020Label }} />
		</div>
	);
};

export default EnergyInformation;
